import { RiAddFill, RiDeleteBinLine } from "react-icons/ri";
import {
  TbCamera,
  TbEditCircle,
  TbPencil,
  TbUserEdit,
  TbBuildingSkyscraper,
  TbBrandMastercard,
  TbCalendar,
  TbBriefcase,
  TbUserDollar,
  TbReceiptDollar,
  TbCalendarCog,
  TbMapPin,
  TbPhotoPin,
 TbFileCertificate, TbFileText,
  TbPlaylistAdd,
  TbBuildingCommunity,
  TbMap2,
  TbWorld,
  TbCurrentLocation,
} from "react-icons/tb";
import Logo from "../../../assets/svgs/logo";
import { useAuthContext } from "../../../context/authContext";
import {
  Box,
  Button,
  Col,
  Dialog,
  Divider,
  FabButton,
  Flex,
  Gap,
  Icon,
  InputField,
  Row,
  SelectField,
  Typography,
} from "../../../ppui";
import { SelectFieldMulti } from "../../../ppui/select-field-multi";
import { Snackbar } from "../../../ppui/snackbar";
import {
  formatToDDMMYYYY,
  getDateProperFormatForInput,
} from "../../../utils/common";
import { safeString } from "../../../utils/logger";
import useCommonfn from "../../../utils/useCommonfn";
import {
  Card,
  CardHeading,
  OrganizationBx,
  OrganizationEmDetails,
  PhotoIcon,
  PhotoUpload,
  RegisterBx,
  RegisterLogo,
} from "../../style";
import { ORGANIZATION_FORM_FIELDS } from "./profile-contants";
import useOrganisationService from "./use-profile-service";
import { useNavigate } from "react-router-dom";

function OrganisationProfile() {
  const navigate = useNavigate();
  const { navigateToDashBoard } = useCommonfn();
  const { orgDetails: fromGblobalorgDetails } = useAuthContext();
  const {
    orgProfile,
    handleClick,
    orgAcName,
    handleChange,
    handleAddRow,
    handleDeleteRow,
    fileInputRef,
    setPreviewURL,
    setSelectedFile,
    previewURL,
    stateList,
    setOrgProfile,
    createUpdateLoading,
    getInputFieldProps,
    snackbarVisible,
    snackbarMessage,
    closeSnackbar,
    snackColor,
    getProfileLoading,
    openSnackbar,
    setErrors,
    handleOpenOrgDetailsModal,
    handleCloseOrgDetailsModal,
    handleOpenOrgActNameModal,
    handleCloseOrgActNameModal,
    handleOpenOrgAddressModal,
    handleCloseOrgAddressModal,
    orgDetailsModal,
    orgActNameModal,
    orgAddressModal,
    getStateName,
    getOrganizationIndustryType,
    getOrganizationCategoryName,
  } = useOrganisationService();
  if (getProfileLoading) {
    return <div>Loading...</div>;
  }

  return (
    <>
      {!fromGblobalorgDetails?.org_name ? (
        <>
          <Gap height={10} />
          <Row>
            <Col sm={12} md={"auto"}>
              <PhotoUpload
                onClick={() => {
                  if (fileInputRef.current) {
                    fileInputRef.current.click();
                  }
                }}
              >
                {!previewURL && <TbUserEdit />}
                <input
                  type="file"
                  id="image"
                  name="image"
                  onChange={(event) => {
                    const file = event.target.files[0];
                    if (file) {
                      const maxSizeInBytes = 2 * 1024 * 1024;
                      if (file.size > maxSizeInBytes) {
                        openSnackbar({
                          message: "File size should not exceed 2 MB.",
                          color: "danger",
                        });

                        return;
                      }
                      const allowedTypes = ["image/jpeg", "image/jpg"];

                      if (!allowedTypes.includes(file.type)) {
                        openSnackbar({
                          message: "Only JPG files are allowed.",
                          color: "danger",
                        });
                        return;
                      }

                      setSelectedFile(file);
                      setPreviewURL(URL.createObjectURL(file));

                      setOrgProfile((prevUser) => ({
                        ...prevUser,
                        logo: file,
                      }));
                    }
                  }}
                  ref={fileInputRef}
                  accept=".jpg, image/jpeg"
                  hidden
                />
                {previewURL && <img src={previewURL} alt="" />}
                <PhotoIcon>
                  <FabButton
                    size="xs"
                    variant="contained"
                    color="primary"
                    icon={previewURL ? <TbEditCircle /> : <TbCamera />}
                  />
                </PhotoIcon>
              </PhotoUpload>
            </Col>
            <Col col-xs={"auto"}>
              <Row rowGap>
                <Col sm={12} md={6} lg={6} xxl={4}>
                  <InputField
                    {...getInputFieldProps(
                      ORGANIZATION_FORM_FIELDS.org_name.name
                    )}
                  />
                </Col>
                <Col sm={12} md={6} lg={6} xxl={4}>
                  <InputField
                    {...getInputFieldProps(
                      ORGANIZATION_FORM_FIELDS.domain_name.name
                    )}
                  />
                </Col>
                <Col sm={12} md={6} lg={6} xxl={4}>
                  <InputField
                    {...getInputFieldProps(ORGANIZATION_FORM_FIELDS.phone.name)}
                  />
                </Col>
                <Col sm={12} md={6} lg={6} xxl={4}>
                  <InputField
                    {...getInputFieldProps(
                      ORGANIZATION_FORM_FIELDS.landline.name
                    )}
                  />
                </Col>
                <Col sm={12} md={6} lg={6} xxl={4}>
                  <InputField
                    {...getInputFieldProps(ORGANIZATION_FORM_FIELDS.email.name)}
                  />
                </Col>
              </Row>
            </Col>
          </Row>
          <Gap height={30} />
          <Row rowGap>
            <Col sm={12} md={6} lg={4} xxl={3}>
              <SelectField
                {...getInputFieldProps(
                  ORGANIZATION_FORM_FIELDS.registration_type.name
                )}
              />
            </Col>
            <Col sm={12} md={6} lg={4} xxl={3}>
              <SelectField
                {...getInputFieldProps(
                  ORGANIZATION_FORM_FIELDS.industry_type.name
                )}
              />
            </Col>
            <Col sm={12} md={6} lg={4} xxl={3}>
              <InputField
                {...getInputFieldProps(ORGANIZATION_FORM_FIELDS.pan.name)}
              />
            </Col>
            <Col sm={12} md={6} lg={4} xxl={3}>
              <InputField
                {...getInputFieldProps(ORGANIZATION_FORM_FIELDS.tan_no.name)}
              />
            </Col>
            <Col sm={12} md={6} lg={4} xxl={3}>
              <InputField
                {...getInputFieldProps(
                  ORGANIZATION_FORM_FIELDS.date_of_org.name
                )}
                valueSinc
                onKeyDown={(e) => e.preventDefault()}
              />
            </Col>

            <Col sm={12} md={6} lg={4} xxl={3}>
              <SelectFieldMulti
                {...getInputFieldProps(
                  ORGANIZATION_FORM_FIELDS.payment_type.name
                )}
              />
            </Col>
            {/* {safeString(orgProfile.payment_type).toLowerCase() === "wages" && <Col sm={12} md={6} lg={4} xxl={3} >
            <SelectField    {...getInputFieldProps(ORGANIZATION_FORM_FIELDS.wages_type.name)}
            />
          </Col>
          } */}

            {orgProfile.payment_type.includes("wages") && (
              <Col sm={12} md={6} lg={4} xxl={3}>
                <SelectField
                  {...getInputFieldProps(
                    ORGANIZATION_FORM_FIELDS.wages_type.name
                  )}
                />
              </Col>
            )}

            {/* {safeString(orgProfile.payment_type).toLowerCase() === "wages" && safeString(orgProfile.wages_type).toLowerCase() === 'fixed_date' && <Col sm={6}>
            <InputField    {...getInputFieldProps(ORGANIZATION_FORM_FIELDS.wages_days.name)}
            />
          </Col>
          } */}
            {orgProfile.payment_type.includes("wages") &&
              safeString(orgProfile.wages_type).toLowerCase() ===
                "fixed_date" && (
                <Col sm={12} md={6} lg={4} xxl={3}>
                  <InputField
                    {...getInputFieldProps(
                      ORGANIZATION_FORM_FIELDS.wages_days.name
                    )}
                  />
                </Col>
              )}
          </Row>

          <Divider gap={20} />
          <Typography variant="h5">Address</Typography>
          <Row rowGap>
            <Col sm={12} md={6} lg={4} xxl={3}>
              <InputField
                {...getInputFieldProps(ORGANIZATION_FORM_FIELDS.address.name)}
              />
            </Col>
            <Col sm={12} md={6} lg={4} xxl={3}>
              <InputField
                {...getInputFieldProps(ORGANIZATION_FORM_FIELDS.city.name)}
              />
            </Col>
            <Col sm={12} md={6} lg={4} xxl={3}>
              <SelectField
                {...getInputFieldProps(ORGANIZATION_FORM_FIELDS.state.name)}
                options={stateList || []}
              />
            </Col>
            <Col sm={12} md={6} lg={4} xxl={3}>
              <SelectField
                {...getInputFieldProps(ORGANIZATION_FORM_FIELDS.country.name)}
              />
            </Col>
            <Col sm={12} md={6} lg={4} xxl={3}>
              <InputField
                {...getInputFieldProps(ORGANIZATION_FORM_FIELDS.pincode.name)}
              />
            </Col>
            <Col sm={12} md={6} lg={4} xxl={3}>
              <InputField
                {...getInputFieldProps(ORGANIZATION_FORM_FIELDS.locality.name)}
              />
            </Col>
            <Col sm={12} md={6} lg={4} xxl={3}>
              <InputField
                {...getInputFieldProps(ORGANIZATION_FORM_FIELDS.landmark.name)}
              />
            </Col>
          </Row>

          <Divider gap={20} />
          <Typography variant="h5">Organisation Act</Typography>
          <Flex direction="column" gap={20}>
            {orgAcName?.map((item, index) => (
              <Row rowGap key={index}>
                <Col lg={8} xxl={6}>
                  <Row>
                    <Col sm={12} md={6}>
                      <InputField
                        fullWidth
                        label="Act Name"
                        placeholder="Type Here..."
                        type="text"
                        value={item.actName}
                        onChange={(e) =>
                          handleChange(index, "actName", e.target.value)
                        }
                        valueSinc={!!item.actName}
                      />
                    </Col>
                    <Col sm={12} md={6}>
                      <InputField
                        fullWidth
                        label="Reg No."
                        placeholder="Type Here..."
                        type="text"
                        value={item.regNo}
                        onChange={(e) =>
                          handleChange(index, "regNo", e.target.value)
                        }
                        valueSinc={!!item.regNo}
                      />
                    </Col>
                  </Row>
                </Col>
                <Col sm={"auto"}>
                  <Flex gap={10}>
                    {index === orgAcName.length - 1 && (
                      <FabButton
                        color="primary"
                        icon={<RiAddFill />}
                        onClick={handleAddRow}
                        shape="box"
                        variant="outlined"
                      />
                    )}

                    <FabButton
                      color="primary"
                      icon={<RiDeleteBinLine />}
                      onClick={() => handleDeleteRow(index)}
                      disabled={orgAcName.length === 1 && true}
                      shape="box"
                      variant="outlined"
                    />
                  </Flex>
                </Col>
              </Row>
            ))}
          </Flex>

          <Gap height={20} />
          <Flex justifyContent="flex-end" gap={"10"}>
            <Button onClick={navigateToDashBoard} variant="outlined">
              Cancel
            </Button>
            <Button
              color="primary"
              type="button"
              onClick={handleClick}
              variant="contained"
              loading={createUpdateLoading}
            >
              Save
            </Button>
          </Flex>
        </>
      ) : (
        <>
          {fromGblobalorgDetails?.status === "approved" ? (
            <><Card>
            <CardHeading  Divider>
                Organization Details
                <FabButton
                  size="sm"
                  icon={<TbPencil />}
                  onClick={() => handleOpenOrgDetailsModal(setErrors)}
                  variant="filled"
                  shape="box"
                />
            </CardHeading>

            <OrganizationEmDetails>
              <OrganizationBx>
                <Icon size={"lg"}>
                  <TbBuildingSkyscraper />
                </Icon>
                <Box>
                  <Typography variant="body1" mb={"0"} color="primary">
                    Organization Category
                  </Typography>
                  <Typography variant="body2"
                    mb={"0"}
                    color="dark"
                    colorVariant="light"
                    textCase="capitalize">
                    {getOrganizationCategoryName(
                      fromGblobalorgDetails?.registration_type
                    ) || "-"}
                  </Typography>
                </Box>
              </OrganizationBx>

              <OrganizationBx>
                <Icon size={"lg"}>
                  <TbBriefcase /> {/* Replace with appropriate icon */}
                </Icon>
                <Box>
                  <Typography variant="body1" mb={"0"} color="primary">
                    Industry Type
                  </Typography>
                  <Typography
                    variant="body2"
                    mb={"0"}
                    color="dark"
                    colorVariant="light"
                    textCase="capitalize"
                  >
                    {getOrganizationIndustryType(
                      fromGblobalorgDetails?.industry_type
                    ) || "-"}
                  </Typography>
                </Box>
              </OrganizationBx>
              <OrganizationBx>
                <Icon size={"lg"}>
                  <TbBrandMastercard /> {/* Replace with appropriate icon */}
                </Icon>
                <Box>
                  <Typography variant="body1" mb={"0"} color="primary">
                    Organization PAN
                  </Typography>
                  <Typography
                    variant="body2"
                    mb={"0"}
                    color="dark"
                    colorVariant="light"
                    textCase="capitalize"
                  >
                    {fromGblobalorgDetails?.pan || "-"}
                  </Typography>
                </Box>
              </OrganizationBx>

              <OrganizationBx>
                <Icon size={"lg"}>
                  <TbBrandMastercard /> {/* Replace with appropriate icon */}
                </Icon>
                <Box>
                  <Typography variant="body1" mb={"0"} color="primary">
                    Organization TAN
                  </Typography>
                  <Typography
                    variant="body2"
                    mb={"0"}
                    color="dark"
                    colorVariant="light"
                    textCase="capitalize"
                  >
                    {fromGblobalorgDetails?.tan_no || "-"}
                  </Typography>
                </Box>
              </OrganizationBx>

              <OrganizationBx>
                <Icon size={"lg"}>
                  <TbCalendar /> {/* Replace with appropriate icon */}
                </Icon>
                <Box>
                  <Typography variant="body1" mb={"0"} color="primary">
                    Date Of Establishment
                  </Typography>
                  <Typography
                    variant="body2"
                    mb={"0"}
                    color="dark"
                    colorVariant="light"
                    textCase="capitalize"
                  >
                    {fromGblobalorgDetails?.date_of_org
                      ? formatToDDMMYYYY(
                          new Date(
                            getDateProperFormatForInput(
                              fromGblobalorgDetails?.date_of_org
                            )
                          )
                        )
                      : "-"}
                  </Typography>
                </Box>
              </OrganizationBx>

              <OrganizationBx>
                <Icon size={"lg"}>
                  <TbUserDollar /> {/* Replace with appropriate icon */}
                </Icon>
                <Box>
                  <Typography variant="body1" mb={"0"} color="primary">
                    Payment Type
                  </Typography>
                  <Typography
                    variant="body2"
                    mb={"0"}
                    color="dark"
                    colorVariant="light"
                    textCase="capitalize"
                  >
                    {fromGblobalorgDetails?.payment_type &&
                      fromGblobalorgDetails?.payment_type.join(", ")}
                  </Typography>
                </Box>
              </OrganizationBx>

              {fromGblobalorgDetails?.wages_type && (
                <OrganizationBx>
                  <Icon size={"lg"}>
                    <TbReceiptDollar /> {/* Replace with appropriate icon */}
                  </Icon>
                  <Box>
                    <Typography variant="body1" mb={"0"} color="primary">
                      Wages Type
                    </Typography>
                    <Typography
                       variant="body2"
                       mb={"0"}
                       color="dark"
                       colorVariant="light"
                       textCase="capitalize"
                    >
                      {fromGblobalorgDetails?.wages_type
                        ? fromGblobalorgDetails?.wages_type === "fixed_date"
                          ? "Fixed Days"
                          : "Monthly"
                        : "-"}
                    </Typography>
                  </Box>
                </OrganizationBx>
              )}

              {fromGblobalorgDetails?.wages_days && (
                <OrganizationBx>
                  <Icon size={"lg"}>
                    <TbCalendarCog /> {/* Replace with appropriate icon */}
                  </Icon>
                  <Box>
                    <Typography variant="body1" mb={"0"} color="primary">
                      Wages Days
                    </Typography>
                    <Typography
                       variant="body2"
                       mb={"0"}
                       color="dark"
                       colorVariant="light"
                       textCase="capitalize"
                    >
                      {fromGblobalorgDetails?.wages_days} days
                    </Typography>
                  </Box>
                </OrganizationBx>
              )}

            </OrganizationEmDetails>
          </Card>
          <Card>
            <CardHeading  Divider>
              Organization Address
              <FabButton
                size="sm"
                icon={<TbPencil />}
                onClick={handleOpenOrgAddressModal}
                variant="filled"
                shape="box"
              />
            </CardHeading>
            <OrganizationEmDetails>
              <OrganizationBx>
                <Icon size={"lg"}>
                  <TbMapPin /> {/* Replace with a suitable address icon, e.g., TbMapPin */}
                </Icon>
                <Box>
                  <Typography variant="body1" mb={"0"} color="primary">
                    Address
                  </Typography>
                  <Typography
                    variant="body2"
                    mb={"0"}
                    color="dark"
                    colorVariant="light"
                    textCase="capitalize"
                  >
                    {fromGblobalorgDetails?.address || "-"}
                  </Typography>
                </Box>
              </OrganizationBx>

              <OrganizationBx>
                <Icon size={"lg"}>
                  <TbBuildingCommunity /> {/* Replace with a city icon, e.g., TbBuilding */}
                </Icon>
                <Box>
                  <Typography variant="body1" mb={"0"} color="primary">
                    City/District
                  </Typography>
                  <Typography
                    variant="body2"
                    mb={"0"}
                    color="dark"
                    colorVariant="light"
                    textCase="capitalize"
                  >
                    {fromGblobalorgDetails?.city || "-"}
                  </Typography>
                </Box>
              </OrganizationBx>

              <OrganizationBx>
                <Icon size={"lg"}>
                  <TbMap2 /> {/* Replace with a state/region icon, e.g., TbMap2 */}
                </Icon>
                <Box>
                  <Typography variant="body1" mb={"0"} color="primary">
                    State
                  </Typography>
                  <Typography
                    variant="body2"
                    mb={"0"}
                    color="dark"
                    colorVariant="light"
                    textCase="capitalize"
                  >
                    {getStateName(fromGblobalorgDetails?.state)}
                  </Typography>
                </Box>
              </OrganizationBx>

              <OrganizationBx>
                <Icon size={"lg"}>
                  <TbWorld /> {/*  TbWorld for Country  */}
                </Icon>
                <Box>
                  <Typography variant="body1" mb={"0"} color="primary">
                    Country
                  </Typography>
                  <Typography
                    variant="body2"
                    mb={"0"}
                    color="dark"
                    colorVariant="light"
                    textCase="capitalize"
                  >
                    India
                  </Typography>
                </Box>
              </OrganizationBx>

              <OrganizationBx>
                <Icon size={"lg"}>
                  <TbCurrentLocation /> {/* TbRegex("[0-9]{6}") or similar for postal code */}
                </Icon>
                <Box>
                  <Typography variant="body1" mb={"0"} color="primary">
                    Pin Code
                  </Typography>
                  <Typography
                    variant="body2"
                    mb={"0"}
                    color="dark"
                    colorVariant="light"
                    textCase="capitalize"
                  >
                    {fromGblobalorgDetails?.pincode || "-"}
                  </Typography>
                </Box>
              </OrganizationBx>

              <OrganizationBx>
                <Icon size={"lg"}>
                  <TbPhotoPin /> {/* TbCurrentLocation is a good choice. */}
                </Icon>
                <Box>
                  <Typography variant="body1" mb={"0"} color="primary">
                    Location
                  </Typography>
                  <Typography
                    variant="body2"
                    mb={"0"}
                    color="dark"
                    colorVariant="light"
                    textCase="capitalize"
                  >
                    {fromGblobalorgDetails?.locality || "-"}
                  </Typography>
                </Box>
              </OrganizationBx>

            </OrganizationEmDetails>
          </Card>
          <Card>
            
            <CardHeading  Divider>
                Organization Act
                {fromGblobalorgDetails.org_acts.length > 0 ? (
                  <FabButton
                    size="sm"
                    icon={<TbPencil />}
                    onClick={() => handleOpenOrgActNameModal()}
                    variant="filled"
                    shape="box"
                  />
                ):
                  <Button
                    size="sm"
                    icon={<TbPlaylistAdd />}
                    onClick={() => handleOpenOrgActNameModal()}
                    variant="contained"
                    color="primary"
                  > Add</Button>
                }
            </CardHeading>
            {fromGblobalorgDetails.org_acts.length === 0 && (
              <>
              <Flex alignItem="center">
              <Typography variant="body2" mb={"0"}>Please enter your Organization Act Details for better visibility.</Typography>
              <Button color="secondary" size="sm" onClick={handleOpenOrgActNameModal}>Click here</Button> 
              </Flex>
              </>
            )}
            {fromGblobalorgDetails?.org_acts?.map((item, index) => (
              <OrganizationEmDetails key={index}>
                <OrganizationBx>
                  <Icon size={"lg"}>
                    <TbFileCertificate /> {/*  Suitable icon for Act Name.  */}
                  </Icon>
                  <Box>
                    <Typography variant="body1" mb={"0"} color="primary">
                      Act Name
                    </Typography>
                    <Typography
                      variant="body2"
                      mb={"0"}
                      color="dark"
                      colorVariant="light"
                      textCase="capitalize"
                    >
                      {item?.act_name || "-"}
                    </Typography>
                  </Box>
                </OrganizationBx>

                <OrganizationBx>
                  <Icon size={"lg"}>
                    <TbFileText /> {/* Suitable for Registration Number */}
                  </Icon>
                  <Box>
                    <Typography variant="body1" mb={"0"} color="primary">
                      Reg No.
                    </Typography>
                    <Typography
                       variant="body2"
                       mb={"0"}
                       color="dark"
                       colorVariant="light"
                       textCase="capitalize"
                    >
                      {item?.reg_no || "-"}
                    </Typography>
                  </Box>
                </OrganizationBx>
              </OrganizationEmDetails>
            ))}
          </Card>
            </>
          ) : (
            <>
              <RegisterBx>
                <RegisterLogo>
                  <Logo/>
                </RegisterLogo>
              </RegisterBx>
              <Gap height={40} />
              <Typography variant="body1" align="center" mb="0">
              Registration Submitted Successfully
              </Typography>

              <Gap height={30} />
               <Row>
                <Col xs={12} md={6} m="auto">
              <Typography variant="h2" lineHeight="1.25" color="primary" align="center" mb="">
               Thanks for registering with Techwens
              </Typography>
              </Col>


              <Col xs={12} md={7} m="auto">
              <Typography variant="body1" mb="0" align="center">
                Kindly wait for the approval process to be completed. Once
                approved, you will receive a notification via email on your
                registered email address. Thank you for your patience.
              </Typography>
              </Col>
              </Row>

             
              <Gap height={30} />
              <Flex justifyContent="center">
                <Button
                  color="primary"
                  variant="contained"
                  size="medium"
                  onClick={() => {
                    localStorage.removeItem("hrms_token");
                    localStorage.removeItem("hrms_admin_token");
                    // setUser(null);
                    if (window.location.pathname.startsWith("/admin")) {
                      navigate("/admin-login");
                    } else {
                      navigate("/");
                    }
                    window.location.reload();
                  }}
                >
                  CONFIRM
                </Button>
              </Flex>
            </>
          )}
        </>
      )}

      {/* Organization-Details-Modal */}
      <Dialog
        title="Organization Details"
        closeButton={true}
        fullWidth
        maxWidth="sm"
        buttonName={"Update"}
        open={orgDetailsModal}
        onClose={handleCloseOrgDetailsModal}
        onSubmit={() => handleClick()}
        btnLoading={createUpdateLoading}
        separator
      >
        <Row rowGap>
          <Col sm={6}>
            <SelectField
              {...getInputFieldProps(
                ORGANIZATION_FORM_FIELDS.registration_type.name
              )}
            />
          </Col>
          {/* <Col sm={6}>
            <InputField
              {...getInputFieldProps(ORGANIZATION_FORM_FIELDS.domain_name.name)}
            />
          </Col> */}

          <Col sm={6}>
            <SelectField
              {...getInputFieldProps(
                ORGANIZATION_FORM_FIELDS.industry_type.name
              )}
            />
          </Col>

          <Col sm={6}>
            <InputField
              {...getInputFieldProps(ORGANIZATION_FORM_FIELDS.pan.name)}
            />
          </Col>

          <Col sm={6}>
            <InputField
              {...getInputFieldProps(ORGANIZATION_FORM_FIELDS.tan_no.name)}
            />
          </Col>

          <Col sm={6}>
            <InputField
              {...getInputFieldProps(ORGANIZATION_FORM_FIELDS.date_of_org.name)}
              valueSinc
              onKeyDown={(e) => e.preventDefault()}
            />
          </Col>

          <Col sm={6}>
            {/* <SelectField
              {...getInputFieldProps(ORGANIZATION_FORM_FIELDS.payment_type.name)}
            /> */}
            <SelectFieldMulti
              {...getInputFieldProps(
                ORGANIZATION_FORM_FIELDS.payment_type.name
              )}
            />
          </Col>
          {orgProfile.payment_type.includes("wages") && (
            <Col sm={6}>
              <SelectField
                {...getInputFieldProps(
                  ORGANIZATION_FORM_FIELDS.wages_type.name
                )}
              />
            </Col>
          )}

          {/* {safeString(orgProfile.payment_type).toLowerCase() === "wages" && safeString(orgProfile.wages_type).toLowerCase() === 'fixed_date' && <Col sm={6}>
            <InputField    {...getInputFieldProps(ORGANIZATION_FORM_FIELDS.wages_days.name)}
            />
          </Col>
          } */}
          {orgProfile.payment_type.includes("wages") &&
            safeString(orgProfile.wages_type).toLowerCase() ===
              "fixed_date" && (
              <Col sm={6}>
                <InputField
                  {...getInputFieldProps(
                    ORGANIZATION_FORM_FIELDS.wages_days.name
                  )}
                />
              </Col>
            )}

          {/* <Col sm={6}>
            <InputField
              {...getInputFieldProps(ORGANIZATION_FORM_FIELDS.landline.name)}
            />
          </Col> */}
        </Row>
      </Dialog>

      {/* Organization-Details-Modal */}

      {/* Organization-Act-Modal */}
      <Dialog
        title="Organization Act Name"
        closeButton={true}
        fullWidth
        maxWidth="sm"
        buttonName={"Update"}
        open={orgActNameModal}
        onClose={handleCloseOrgActNameModal}
        onSubmit={() => handleClick(undefined, "ACT_NO")}
        btnLoading={createUpdateLoading}
        separator
      >
        {orgAcName?.map((item, index) => (
          <Row rowGap key={index} mb={20}>
            <Col sm={9}>
              <Row>
                <Col sm={6}>
                  <InputField
                    fullWidth
                    label="Act Name"
                    placeholder="Type Here..."
                    type="text"
                    value={item.actName}
                    onChange={(e) =>
                      handleChange(index, "actName", e.target.value)
                    }
                    valueSinc={!!item.actName}
                  />
                </Col>
                <Col sm={6}>
                  <InputField
                    fullWidth
                    label="Reg No."
                    placeholder="Type Here..."
                    type="text"
                    value={item.regNo}
                    onChange={(e) =>
                      handleChange(index, "regNo", e.target.value)
                    }
                    valueSinc={!!item.regNo}
                  />
                </Col>
              </Row>
            </Col>

            <Col sm={3}>
              <Flex gap={10}>
                {index === orgAcName.length - 1 && (
                  <FabButton
                    color="primary"
                    icon={<RiAddFill size={"small"} />}
                    onClick={handleAddRow}
                    shape="box"
                    variant="outlined"
                  />
                )}
                <FabButton
                  color="primary"
                  icon={<RiDeleteBinLine />}
                  disabled={orgAcName.length === 1 && true}
                  onClick={() => handleDeleteRow(index)}
                  shape="box"
                  variant="outlined"
                />
              </Flex>
            </Col>
          </Row>
        ))}
      </Dialog>
      {/* Organization-Act-Modal */}

      {/* Organization-Address-Modal */}
      <Dialog
        title="Organization Address"
        closeButton={true}
        fullWidth
        maxWidth="sm"
        buttonName={"Update"}
        open={orgAddressModal}
        onClose={handleCloseOrgAddressModal}
        onSubmit={() => handleClick()}
        btnLoading={createUpdateLoading}
        separator
      >
        <Row rowGap>
          <Col sm={6}>
            <InputField
              {...getInputFieldProps(ORGANIZATION_FORM_FIELDS.address.name)}
            />
          </Col>
          <Col sm={6}>
            <InputField
              {...getInputFieldProps(ORGANIZATION_FORM_FIELDS.city.name)}
            />
          </Col>

          <Col sm={6}>
            <SelectField
              {...getInputFieldProps(ORGANIZATION_FORM_FIELDS.state.name)}
              options={stateList || []}
            />
          </Col>

          <Col sm={6}>
            <SelectField
              {...getInputFieldProps(ORGANIZATION_FORM_FIELDS.country.name)}
            />
          </Col>

          <Col sm={6}>
            <InputField
              {...getInputFieldProps(ORGANIZATION_FORM_FIELDS.pincode.name)}
            />
          </Col>

          <Col sm={6}>
            <InputField
              {...getInputFieldProps(ORGANIZATION_FORM_FIELDS.locality.name)}
            />
          </Col>
        </Row>
      </Dialog>
      {/* Organization-Address-Modal */}

      <Snackbar
        message={snackbarMessage}
        color={snackColor}
        variant="contained"
        size="medium"
        position="top-right"
        onClose={closeSnackbar}
        onOpen={snackbarVisible}
        loading={false}
        duration={3000}
      />
    </>
  );
}

export default OrganisationProfile;
